import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { store } from './store';
import ActionCable from 'actioncable';
import { ActionCableProvider } from 'react-actioncable-provider';
import Snackbar from './components/snackbar/snackbar';
const cable = ActionCable.createConsumer("/__cable");


ReactDOM.render(
  <Provider store={store}>
    <ActionCableProvider cable={cable}>
      <App />
      <Snackbar />
    </ActionCableProvider>
  </Provider>,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js